import {
  DiscountState,
  REQUEST_DISCOUNTS,
  REQUEST_DISCOUNTS_DONE
} from "./types";

const initialState: DiscountState = {
  discounts: [],
  discountTypes: [],
  isLoading: true
};

export function reducer(state = initialState, action: any): DiscountState {
  switch (action.type) {
    case REQUEST_DISCOUNTS:
      return { ...action.payload, isLoading: true };
    case REQUEST_DISCOUNTS_DONE:
      return { ...action.payload, isLoading: false };
    default:
      return state;
  }
}
